import styled from 'styled-components';
import colors from '@theme/colors';

export const ListContainer = styled.div`
  overflow-y: scroll;
`;

export const Container = styled.div`
  background-color: ${colors.FORUM_GREY};
  display: flex;
  flex-direction: column;
  height: 100%;

  > ${ListContainer} {
    flex: 1;
  }
`;



// WEBPACK FOOTER //
// ./components/organisms/UserList/layout.js